import { render, staticRenderFns } from "./secondary_category.vue?vue&type=template&id=163049e2&"
import script from "./secondary_category.vue?vue&type=script&lang=js&"
export * from "./secondary_category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports